import { gql } from "@apollo/client";

const CALL_ADDED = gql`
  subscription callAdded($where: CallWhereInput) {
    callAdded(where: $where) {
      id
      aircallId
      direction
      phoneNumber
      duration
      startedAt
      answeredAt
      endedAt
      dialedAt
      userName
      user {
        id
        firstname
        lastname
      }
      missedCallReason
      recordingAvailable
      status
    }
  }
`;

const call = { CALL_ADDED };

export default call;
